import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input,
  OnDestroy
} from '@angular/core';
import {ImageZoomComponent} from './image-zoom.component';

@Directive({
    selector: '[dbImageZoom]',
    standalone: false
})
export class ImageZoomDirective implements OnDestroy {

  @Input('dbImageZoom') content: string;
  @Input('dbImageZoomDelay') delay: number;
  @Input('dbImageZoomProductType') type: string;

  private _imageZoomComponentRef: ComponentRef<ImageZoomComponent>;

  constructor(
    private _element: ElementRef,
    private _applicationRef: ApplicationRef,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) {}

  @HostListener('mouseenter') mouseenter() {
    this.showTooltip();
  }

  private showTooltip(): void {
    if (this.type === 'theme') {
      if (this._imageZoomComponentRef) {
        return;
      }

      if (!this.content) {
        return;
      }

      // create a imageZoom component reference
      this._imageZoomComponentRef = this._componentFactoryResolver.resolveComponentFactory(ImageZoomComponent).create(this._injector);
      this._imageZoomComponentRef.instance.host = this._element.nativeElement;
      this._imageZoomComponentRef.instance.content = this.content;
      this._imageZoomComponentRef.instance.delay = this.delay;

      // attach component to the applicationRef so that it will be dirty checked.
      this._applicationRef.attachView(this._imageZoomComponentRef.hostView);

      // get DOM element from component
      const imageZoomComponentElement: HTMLElement = (this._imageZoomComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

      document.body.appendChild(imageZoomComponentElement);
    }
  }

  private hideTooltip(): void {
    if (this.type === 'theme') {
      this._imageZoomComponentRef && this._imageZoomComponentRef.destroy();
      this._imageZoomComponentRef = null;
    }
  }

  @HostListener('mouseleave') mouseleave() {
    this.hideTooltip();
  }

  ngOnDestroy() {
    this.hideTooltip();
  }

}
